import { render, staticRenderFns } from "./UnregisteredConnections.vue?vue&type=template&id=5aee962d&lang=pug&"
import script from "./UnregisteredConnections.vue?vue&type=script&lang=ts&"
export * from "./UnregisteredConnections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports